<template>
    <v-autocomplete
            :items="classes"
            :search-input.sync="searchQuery"
            :loading="isLoading"
            label="Pick a class"
            item-value="value"
            item-text="text"
            v-model="selectedClassId"
            clearable
            clear-icon="close"
            prepend-inner-icon="face"
            @input="onInputChanged"
    ></v-autocomplete>
</template>

<script>
    import {UrlUtils} from '../utils/UrlUtils'
    import {Student} from "../state/models/Student";

    export default {
        name: "ClassPickerAutocomplete",
        props: {
            useQueryString: false
        },
        data: function() {
            return {
                classes: [],
                selectedClassId: null,
                searchQuery: null,
                isLoading: false
            };
        },
        methods: {
            onInputChanged() {
                this.updateQueryStringIfOn();
                this.$emit('input', this.selectedClassId);
            },
            updateQueryStringIfOn() {
                if (this.useQueryString) {
                    UrlUtils.updateQueryStringParam('classId', this.selectedClassId);
                }
            },
        },
        watch: {
            searchQuery (val) {
                // Items have already been loaded
                if (this.classes.length > 0) {
                    return;
                }

                // Items have already been requested
                if (this.isLoading) {
                    return;
                }

                this.isLoading = true;

                this.$store.dispatch('searchClasses', {searchQ: val})
                    .then((sList) => {
                        this.classes = sList;
                    })
                    .finally(() => (this.isLoading = false))
            }
        },
        mounted() {
            this.$store.dispatch('getClasses')
                .then((sList) => {
                    if (!sList || !sList.length) {
                        return Promise.reject('Classes were not found');
                    }
                    this.classes = sList.map(s => {return {value: s.id, text: s.name}});

                    if (this.useQueryString) {
                        // check if there is a class id on the query string
                        let classIdFromQuery = +this.$router.currentRoute.query['classId'];
                        if (classIdFromQuery) {
                            this.selectedClassId = classIdFromQuery;
                        }
                    }
                });
        }
    }
</script>

<style scoped>

</style>
